class Megamenu {
  constructor(container) {
    this.selectors = {
      announcementBar: ".m-announcement-bar",
      menuToggle: ".m-menu-button",
      desktopMenuItems: [".m-menu__item"],
      desktopSubMenus: ".m-mega-menu",
      headerMobile: ".m-header__mobile",
      menuDrawer: "#m-menu-drawer",
      menuDrawerContent: ".m-menu-drawer__content",
      menu: ".m-menu-mobile",
      menuItems: [".m-menu-mobile__item"],
      megaMenuMobile: [".m-megamenu-mobile"],
      backDrop: ".m-menu-drawer__backdrop",
    };
    this.menuSelectors = {
      subMenu: ".m-mega-menu",
    };
    this.activeDesktopMenuItem = null;
    this.previouslyFocusedElement = null;

    this.sliders = {};
    this.open = false;
    this.container = container;
    this.transitionDuration = 0;
    this.domNodes = queryDomNodes(this.selectors);
    this.menuData = [...this.domNodes.desktopMenuItems].map((item) => {
      const header = item.closest("header");
      const menuNodes = queryDomNodes(this.menuSelectors, item);
      return { header, item, ...menuNodes, active: false };
    });
    this.init();

    MinimogTheme = MinimogTheme || {};
    MinimogTheme.headerSliders = this.sliders;
  }

  init() {
    const { menuToggle, menuDrawer, headerMobile, backDrop } = this.domNodes;
    if (!menuToggle || !menuDrawer || !headerMobile || !backDrop) return;

    this.handleMenuToggleClick = () => {
      if (this.open) {
        this.closeMenu();
      } else {
        this.openMenu();
      }
    };
    menuToggle.addEventListener("click", this.handleMenuToggleClick);
    menuToggle.dataset.tfMegaMenuBound = "true";

    backDrop.addEventListener("click", () => {
      this.closeMenu();
    });
    document.addEventListener("keydown", this.handleDocumentKeydown);
    this.initMobileMegaMenu();
    this.initDesktopMegaMenu();

    MinimogEvents.subscribe(MinimogTheme.pubSubEvents.openCartDrawer, () => {
      this.open && this.closeMenu();
    });
    MinimogEvents.subscribe(MinimogTheme.pubSubEvents.openSearchPopup, () => {
      this.open && this.closeMenu();
    });
  }
  initDesktopMegaMenu() {
    [...this.menuData].forEach((menuItem) => {
      const { item, subMenu } = menuItem;
      if (subMenu) {
        const productsBanner = subMenu.querySelector(".m-mega-product-list");
        if (productsBanner) {
          if (window && window.__sfWindowLoaded) {
            menuItem.productsBannerSlider = this.initProductsBanner(productsBanner);
          } else {
            window.addEventListener("load", () => {
              menuItem.productsBannerSlider = this.initProductsBanner(productsBanner);
            });
          }
        }
      }
    });
  }
  closeDesktopSubmenu = (menuItemIndex) => {
    const menuItem = this.menuData[menuItemIndex];
    const { header } = menuItem;
    header && header.classList.remove("show-menu");
  };
  initProductsBanner(banner) {
    const header = banner.closest("header");
    const menuItem = banner.closest(".m-menu__item");
    const screenClass = (header && `.${header.dataset.screen}`) || "";

    const id = banner.dataset.id;
    const sliderContainer = document.querySelector(`.m-product-list-${id}`);
    const columns = sliderContainer.dataset.column;

    let slider;
    slider = new MinimogLibs.Swiper(`${screenClass} .m-product-list-${id}`, {
      slidesPerView: 1,
      loop: false,
      autoplay: false,
      breakpoints: {
        1200: { slidesPerView: columns },
        992: { slidesPerView: columns >= 2 ? 2 : columns },
      },
    });
    this.sliders[menuItem.dataset.index] = slider;

    if (slider) {
      const prevBtn = document.querySelector(`#m-slider-controls-${id} .m-slider-controls__button-prev`);
      const nextBtn = document.querySelector(`#m-slider-controls-${id} .m-slider-controls__button-next`);
      prevBtn && prevBtn.addEventListener("click", () => slider.slidePrev());
      nextBtn && nextBtn.addEventListener("click", () => slider.slideNext());
    }
  }

  initMobileMegaMenu() {
    [...this.domNodes.menuItems].forEach((item) => {
      const subMenuContainer = item.querySelector(":scope > .m-megamenu-mobile");
      const backBtn = subMenuContainer && subMenuContainer.querySelector(":scope > .m-megamenu-mobile__wrapper > .m-menu-mobile__back-button");
      const toggleControl = item.querySelector(":scope > .m-menu-mobile__toggle-button");

      if (subMenuContainer) {
        addEventDelegate({
          context: item,
          selector: "[data-toggle-submenu]",
          handler: (e, target) => {
            if (target.closest(".m-menu-mobile__item") !== item) return;
            e.preventDefault();
            const level = target.dataset.toggleSubmenu;
            this.openSubMenu(subMenuContainer, level, toggleControl || target);
          },
        });
      }

      if (backBtn) {
        backBtn.addEventListener("click", (e) => {
          const level = e.currentTarget.dataset.level;
          this.closeSubMenu(subMenuContainer, level);
        });
      }
    });

    document.addEventListener("matchMobile", () => this.setMenuHeight());
    document.addEventListener("unmatchMobile", () => this.setMenuHeight());
  }

  //////////////// MOBILE MENU EVENTS
  openMenu() {
    this.previouslyFocusedElement = document.activeElement;
    this.setMenuHeight();
    document.documentElement.classList.add("prevent-scroll");
    this.domNodes.menuDrawer.classList.add("open");
    this.domNodes.menuDrawer.setAttribute("aria-hidden", "false");
    this.domNodes.menuDrawer.querySelector(".m-menu-drawer__wrapper").removeAttribute("inert");
    this.domNodes.headerMobile.classList.add("header-drawer-open");
    this.domNodes.menuToggle.setAttribute("aria-expanded", "true");
    this.domNodes.menuToggle.querySelector(".m-hamburger-box")?.classList.add("active");
    this.open = true;

    const focusFirstControl = () => {
      const firstControl = this.domNodes.menuDrawer.querySelector(
        ".m-menu-mobile > .m-menu-mobile__item > a, .m-menu-mobile > .m-menu-mobile__item > button"
      );
      if (this.open && firstControl && !this.domNodes.menuDrawer.contains(document.activeElement)) {
        firstControl.focus();
      }
    };
    requestAnimationFrame(focusFirstControl);
    setTimeout(focusFirstControl, 60);
  }

  closeMenu() {
    const { menuDrawer, menu, megaMenuMobile, menuToggle } = this.domNodes;

    menuToggle.setAttribute("aria-expanded", "false");
    menuToggle.querySelector(".m-hamburger-box")?.classList.remove("active");

    if (menuDrawer.contains(document.activeElement)) {
      if (this.previouslyFocusedElement?.isConnected) {
        this.previouslyFocusedElement.focus();
      } else {
        menuToggle.focus();
      }
    }
    menuDrawer.setAttribute("aria-hidden", "true");

    setTimeout(() => {
      megaMenuMobile.forEach((container) => {
        container.classList.remove("open");
        container.setAttribute("aria-hidden", "true");
        container.setAttribute("inert", "");
      });
      menuDrawer.querySelectorAll("[data-toggle-submenu][aria-expanded]").forEach((control) => {
        control.setAttribute("aria-expanded", "false");
      });
      menu && menu.classList.remove("m-submenu-open", "m-submenu-open--level-1", "m-submenu-open--level-2");
      menuDrawer.classList.remove("open");
      menuDrawer.querySelector(".m-menu-drawer__wrapper").setAttribute("inert", "");
      document.documentElement.classList.remove("prevent-scroll");
      this.domNodes.headerMobile.classList.remove("header-drawer-open");
      // Close search
    }, this.transitionDuration);
    this.open = false;
  }

  openSubMenu(subMenuContainer, level, trigger) {
    let subMenuOpenClass = `m-submenu-open--level-${level}`;

    subMenuContainer._tfTrigger = trigger;
    trigger?.setAttribute("aria-expanded", "true");
    subMenuContainer.setAttribute("aria-hidden", "false");
    subMenuContainer.removeAttribute("inert");
    this.domNodes.menuDrawerContent.classList.add("open-submenu");
    this.domNodes.menu && this.domNodes.menu.classList.add("m-submenu-open");
    this.domNodes.menu && this.domNodes.menu.classList.add(subMenuOpenClass);
    subMenuContainer.classList.add("open");

    requestAnimationFrame(() => {
      subMenuContainer.querySelector(".m-menu-mobile__back-button")?.focus();
    });
  }

  closeSubMenu(subMenuContainer, level) {
    let subMenuOpenClass = `m-submenu-open--level-${level}`;

    level === "1" && this.domNodes.menu && this.domNodes.menu.classList.remove("m-submenu-open");
    this.domNodes.menu && this.domNodes.menu.classList.remove(subMenuOpenClass);
    subMenuContainer.classList.remove("open");
    subMenuContainer.setAttribute("aria-hidden", "true");
    subMenuContainer.setAttribute("inert", "");
    subMenuContainer._tfTrigger?.setAttribute("aria-expanded", "false");
    subMenuContainer._tfTrigger?.focus();
    if (!this.domNodes.menuDrawer.querySelector(".m-megamenu-mobile.open")) {
      this.domNodes.menuDrawerContent.classList.remove("open-submenu");
    }
  }

  handleDocumentKeydown = (event) => {
    if (!this.open) return;

    if (event.key === "Escape") {
      event.preventDefault();
      const openSubmenus = [...this.domNodes.menuDrawer.querySelectorAll(".m-megamenu-mobile.open")];
      const activeSubmenu = openSubmenus[openSubmenus.length - 1];
      if (activeSubmenu) {
        const backButton = activeSubmenu.querySelector(".m-menu-mobile__back-button");
        this.closeSubMenu(activeSubmenu, backButton?.dataset.level || "1");
      } else {
        this.closeMenu();
      }
      return;
    }

    if (event.key !== "Tab") return;

    const openSubmenus = [...this.domNodes.menuDrawer.querySelectorAll(".m-megamenu-mobile.open")];
    const focusScope = openSubmenus[openSubmenus.length - 1] || this.domNodes.menuDrawerContent;
    const focusable = [...focusScope.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )].filter((element) => {
      return !element.closest(".m-megamenu-mobile:not(.open)") && element.getClientRects().length > 0;
    });

    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (!focusScope.contains(document.activeElement)) {
      event.preventDefault();
      (event.shiftKey ? last : first).focus();
    } else if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  setMenuHeight() {
    const { menuDrawer, headerMobile } = this.domNodes;
    const offsetBottom = headerMobile.getBoundingClientRect().bottom;
    const panelHeight = window.innerHeight - offsetBottom;

    menuDrawer.style.setProperty("--menu-drawer-height", `${panelHeight}px`);
  }
}
class SiteNav {
  constructor(container) {
    this.selectors = {
      menuItems: [".m-menu .m-menu__item"],
      dropdowns: [".m-mega-menu"],
      subMenu: ".m-mega-menu",
      overlay: ".m-header__overlay",
      swiper: ".swiper-container",
    };

    this.classes = {
      slideFromRight: "slide-from-right",
      slideReveal: "slide-reveal",
      active: "m-mega-active",
    };

    this.headerSticky = false;

    if (!container) return;
    this.container = container;
    this.domNodes = queryDomNodes(this.selectors, this.container);
    this.activeIndex = -1;
    this.lastActiveIndex = -1;
    this.visited = false;
    this.timeoutEnter = null;
    this.timeoutLeave = null;
    this.attachEvents();
  }

  attachEvents = () => {
    this.domNodes.menuItems.forEach((menuItem, index) => {
      menuItem.addEventListener("mouseenter", (evt) => this.onMenuItemEnter(evt, index));
      menuItem.addEventListener("mouseleave", (evt) => this.onMenuItemLeave(evt, index));
      menuItem.addEventListener("focusin", () => this.onMenuItemEnter({ target: menuItem }, index));
      menuItem.addEventListener("focusout", (evt) => {
        if (!menuItem.contains(evt.relatedTarget)) {
          this.onMenuItemLeave({ target: menuItem }, index);
        }
      });
      menuItem.addEventListener("keydown", (evt) => this.onMenuItemKeydown(evt, index));

      const trigger = menuItem.querySelector(":scope > .m-menu__link--main");
      const submenu = menuItem.querySelector(":scope > .m-mega-menu");
      if (trigger && submenu) {
        if (!submenu.id) submenu.id = `DesktopSubmenu-${index}`;
        trigger.setAttribute("aria-haspopup", "true");
        trigger.setAttribute("aria-controls", submenu.id);
        trigger.setAttribute("aria-expanded", "false");
      }

      menuItem.querySelectorAll(".m-sub-menu__item--level-1").forEach((childItem, childIndex) => {
        const childTrigger = childItem.querySelector(":scope > .m-menu__link");
        const childSubmenu = childItem.querySelector(":scope > .m-mega-menu__column");
        if (!childTrigger || !childSubmenu) return;

        if (!childSubmenu.id) childSubmenu.id = `DesktopSubmenu-${index}-${childIndex}`;
        childTrigger.setAttribute("aria-haspopup", "true");
        childTrigger.setAttribute("aria-controls", childSubmenu.id);
        childTrigger.setAttribute("aria-expanded", "false");
        childItem.addEventListener("focusin", () => childTrigger.setAttribute("aria-expanded", "true"));
        childItem.addEventListener("focusout", (evt) => {
          if (!childItem.contains(evt.relatedTarget)) childTrigger.setAttribute("aria-expanded", "false");
        });
      });
    });
  };

  initDropdownSize = () => {
    this.container && this.container.style.setProperty("--sf-dropdown-width", this.windowWidth());
    this.container && this.container.style.setProperty("--sf-dropdown-height", this.windowHeight());
  };

  onMenuItemEnter = (evt, index) => {
    const { target } = evt;

    if (!target.querySelector(":scope > .m-mega-menu")) return;

    clearTimeout(this.timeoutLeave);
    this.activeIndex = target.dataset && Number(target.dataset.index);
    this.headerSticky = this.container && this.container.dataset.sticky === "true";
    this.reInitSlider(target);

    this.container && this.visited
      ? this.container.classList.remove(this.classes.slideReveal)
      : this.container.classList.add(this.classes.slideReveal);

    this.visited = true;
    this.lastActiveIndex >= 0 &&
      this.activeIndex >= 0 &&
      (this.container && this.lastActiveIndex < this.activeIndex
        ? this.container.classList.add(this.classes.slideFromRight)
        : this.lastActiveIndex > this.activeIndex && this.container.classList.remove(this.classes.slideFromRight));

    this.getElementBoundingRect(target).then((rect) => {
      if (rect) {
        this.container && this.container.style.setProperty("--sf-dropdown-width", rect.width);
        this.container && this.container.style.setProperty("--sf-dropdown-height", rect.height);
      }

      this.timeoutEnter = setTimeout(() => {
        if (this.activeIndex !== Number(target.dataset.index)) return;
        this.container && this.container.classList.add(this.classes.active);
        target.closest(".m-menu__item").classList.add("m-menu__item--active");
        target.querySelector(":scope > .m-menu__link--main")?.setAttribute("aria-expanded", "true");
        // document.documentElement.classList.add("prevent-scroll");
      }, 120);
    });
  };

  onMenuItemLeave = (evt, index) => {
    // console.log(evt, 'leave')
    this.activeIndex = -1;
    this.lastActiveIndex = index;
    evt.target.closest(".m-menu__item").classList.remove("m-menu__item--active");
    evt.target
      .closest(".m-menu__item")
      .querySelector(":scope > .m-menu__link--main")
      ?.setAttribute("aria-expanded", "false");
    // document.documentElement.classList.remove("prevent-scroll");

    this.timeoutLeave = setTimeout(() => {
      if (this.activeIndex === -1 || this.activeIndex < 0) {
        this.visited = false;
      }
      this.resetMegaMenu(evt.target);
    }, 80);
  };

  onMenuItemKeydown = (evt, index) => {
    const menuItem = this.domNodes.menuItems[index];
    const trigger = menuItem?.querySelector(":scope > .m-menu__link--main");
    const submenu = menuItem?.querySelector(":scope > .m-mega-menu");
    if (!trigger) return;

    if (evt.key === "Escape" && submenu) {
      evt.preventDefault();
      this.onMenuItemLeave({ target: menuItem }, index);
      trigger.focus();
      return;
    }

    if (evt.key === "ArrowDown" && document.activeElement === trigger && submenu) {
      evt.preventDefault();
      this.onMenuItemEnter({ target: menuItem }, index);
      window.setTimeout(() => {
        submenu.querySelector('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')?.focus();
      }, 130);
      return;
    }

    if (document.activeElement !== trigger || !["ArrowLeft", "ArrowRight", "Home", "End"].includes(evt.key)) {
      return;
    }

    evt.preventDefault();
    const triggers = this.domNodes.menuItems
      .map((item) => item.querySelector(":scope > .m-menu__link--main"))
      .filter(Boolean);
    const currentIndex = triggers.indexOf(trigger);
    let nextIndex = currentIndex;

    if (evt.key === "Home") nextIndex = 0;
    if (evt.key === "End") nextIndex = triggers.length - 1;
    if (evt.key === "ArrowRight") nextIndex = (currentIndex + 1) % triggers.length;
    if (evt.key === "ArrowLeft") nextIndex = (currentIndex - 1 + triggers.length) % triggers.length;
    triggers[nextIndex]?.focus();
  };

  reInitSlider = (menuItem) => {
    const swiper = menuItem.querySelector(this.selectors.swiper);
    if (!swiper) return;
    const itemIndex = menuItem.dataset.index;
    const slider = MinimogTheme && MinimogTheme.headerSliders[itemIndex];
    slider && slider.update();
  };

  getElementBoundingRect = async (element) => {
    const subMenu = element.querySelector(this.selectors.subMenu);
    if (subMenu) {
      const rect = subMenu.getBoundingClientRect();
      return {
        width: rect.width,
        height: rect.height,
        left: rect.left,
        top: rect.top,
      };
    }
  };

  resetMegaMenu = () => {
    this.activeIndex = -1;

    clearTimeout(this.timeoutEnter);
    this.domNodes.menuItems.forEach((item) => {
      item.classList.remove("m-menu__item--active");
      item.querySelector(":scope > .m-menu__link--main")?.setAttribute("aria-expanded", "false");
    });
    this.container &&
      this.container.classList.remove(
        this.classes.active,
        this.classes.slideFromRight,
        this.classes.slideReveal,
        "sf-header--bg-black",
        "sf-header--bg-white"
      );
  };

  windowWidth = () => {
    return window.innerWidth;
  };
  windowHeight = () => {
    return window.innerHeight;
  };

  destroy = () => {
    this.domNodes.menuItems.forEach((menuItem, index) => {
      menuItem.removeEventListener("mouseenter", (evt) => this.onMenuItemEnter(evt, index));
      menuItem.removeEventListener("mouseleave", (evt) => this.onMenuItemLeave(evt, index));
    });
  };
}

function ensureMegamenuInitialized() {
  const header = document.querySelector("m-header");
  const menuToggle = document.querySelector(".m-menu-button");
  if (!header || !menuToggle || menuToggle.dataset.tfMegaMenuBound === "true") return;

  try {
    const megaMenu = new Megamenu(header);
    if (!header.megamenu) header.megamenu = megaMenu;
  } catch (error) {
    console.error("TradeFrame menu initialization failed", error);
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", ensureMegamenuInitialized, { once: true });
} else {
  ensureMegamenuInitialized();
}
document.addEventListener("shopify:section:load", ensureMegamenuInitialized);
